var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:{
    'disabled-btn': _vm.disable === 'inactive',
    'primary-btn': _vm.disable === 'active',
  },on:{"click":_vm.clickHandler}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }